import dayjs, { DayjsInput } from 'utils/dayjs'
import { DATE_FORMAT } from '~constants'
import { MonthProps } from '~types'

export const getValidShows = (events: any[]) =>
  events.filter(event => {
    const pullDownTime = dayjs.utc(event.date_time).add(1, 'hour').valueOf()
    return dayjs.utc().valueOf() <= pullDownTime
  })

// Helper function to format the month
export const formatMonth = (date: DayjsInput): MonthProps => {
  const d = dayjs?.isDayjs(date) ? date : dayjs(date as string)
  if (!d) return { label: '', value: '', shortLabel: '' }
  return {
    label: d.format(DATE_FORMAT.MONTH_YEAR_LABEL),
    value: d.format(DATE_FORMAT.MONTH_YEAR_VALUE),
    shortLabel: d.format(DATE_FORMAT.MONTH_YEAR_SHORT)
  }
}
